import SEO from "@/components/SEO";
import { PageHero, Reveal, Section, Rich, UL, Callout, BtnPrimary, BtnGhost } from "@/components/Bits";

export default function ForCustomers() {
  return (
    <div data-testid="for-customers-page">
      <SEO
        title="For Customers"
        description="Everything a Middle Man customer needs — how booking works, OTP-secured jobs, live tracking, cancellation rules and your responsibilities."
        path="/for-customers"
      />
      <PageHero
        kicker="For customers"
        title="Book trusted help in minutes."
        subtitle="From medicine pickup and grocery runs to government paperwork — post a job, get matched with a nearby verified Middle Man, and track it live."
      />

      <div className="mx-auto max-w-3xl px-6 py-16 md:py-20">
        <div className="space-y-14">
          <Reveal>
            <Section title="How booking works">
              <UL items={[
                "Post a work request choosing a category and a nearby verified helper.",
                "Your Middle Man accepts, travels, and completes the job — with real-time tracking and OTP-secured start / finish.",
                "Ratings & reviews keep quality high; suspicious or fraudulent accounts are suspended.",
                "Prices are shown up-front — fixed per-hour / per-visit / per-job rates or a negotiable budget agreed before starting.",
                "Any additional charges (materials, transport) must be pre-approved by you.",
              ]} />
            </Section>
          </Reveal>

          <Reveal>
            <Section title="Your responsibilities">
              <UL items={[
                "Provide accurate address, location, contact number and task details.",
                "Be reachable during the booked slot; respond to OTPs promptly.",
                "Pay the agreed amount promptly and honestly.",
                "Treat the Middle Man with respect. Any harassment, discrimination, or abuse results in permanent ban.",
                "Do not request illegal or unsafe work.",
              ]} />
            </Section>
          </Reveal>

          <Reveal>
            <Section title="Cancellations & refunds, at a glance">
              <UL items={[
                "Service work: cancel free of charge before the Middle Man has begun travelling or performing the task.",
                "After the Middle Man has begun travelling or performing, a fair portion of the agreed price may be retained to cover time and expenses, per the cancellation rules shown at the time of cancellation.",
                "Product orders: cancel in-app while the order is pending; after the seller accepts, changes are handled directly with the seller.",
                "Product payments are settled directly with the Middle Man (cash or UPI) — the platform does not collect, hold or reverse product payments.",
                "If a Middle Man cannot complete a task, both parties are notified and you may cancel or reassign.",
              ]} />
              <Rich text="Full detail lives in the **Refund, Cancellation & Delivery Policy** and the **Product Order & Delivery Terms**." />
            </Section>
          </Reveal>

          <Reveal>
            <Section title="Always use Send Work">
              <Rich text="For every job, use the in-app **Send Work** flow. It creates a permanent record, enables OTP-secured start & completion, live tracking, and a one-tap complaint route. Off-platform bookings waive dispute-resolution support." />
            </Section>
          </Reveal>

          <Reveal>
            <Callout>
              <Rich text="**Golden rule:** If a job involves cash, gold, cards, PINs or OTPs — don't assign it. See our Safety page for the full list of prohibited high-risk work." />
            </Callout>
          </Reveal>

          <Reveal>
            <div className="flex flex-wrap gap-4 pt-2">
              <BtnPrimary to="/download" testid="customers-download-btn">Get the app</BtnPrimary>
              <BtnGhost to="/safety" testid="customers-safety-btn">Read safety guidelines</BtnGhost>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  );
}
